/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import store from "./store";

require('./bootstrap');

window.Vue = require('vue').default;

import Vuex from 'vuex';
import Cookies from 'js-cookie';
import Multiselect from "vue-multiselect";
import App from './App.vue';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import axios from 'axios';
import { routes } from './routes';
import { BModal } from 'bootstrap-vue'
import { AlertPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { NavbarPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { SpinnerPlugin } from 'bootstrap-vue'
import { BTable } from 'bootstrap-vue'
import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue2'


// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(Vuex)
Vue.component('multiselect', Multiselect)

Vue.component('b-modal', BModal)
Vue.use(AlertPlugin)
Vue.use(ButtonPlugin)
Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin)
Vue.use(CardPlugin)
Vue.use(ListGroupPlugin)
Vue.use(SpinnerPlugin)
Vue.component('b-table', BTable)
Vue.use( CKEditor );

// Vue.use(IconsPlugin)
// Vue.use(BootstrapVue)

// authorization
if(Cookies.get('JWT') !== undefined){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + Cookies.get('JWT');
}

const router = new VueRouter({
    mode: 'history',
    routes: routes
});

axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 401) {
        router.push( '/');
    }
})

const app = new Vue({
    el: '#app',
    router: router,
    render: h => h(App),
    store: store
});
